module.exports = __webpack_public_path__ + "static/logo-49a0c251440517b772b8b21bed456d14.png";